import { gql } from '@apollo/client';

export const GET_CANVAS_BY_ID = gql`
  query GetProjectById($id: ID!) {
    getEditorCanvas(id: $id) {
      objectId
      metadata
      defunto_pointer {
        nome
        cognome
        forno
        cimitero
        objectId
      }
      editor_canvas_pages {
        edges {
          node {
            preview {
              url
            }
          }
        }
      }
      editor_project_types_pointer {
        name
      }
    }
  }
`;

export const FIND_USER_CANVASES = gql`
  query FindUserCanvases(
    $limit: Int!
    $where: Editor_canvasWhereInput
    $after: String
  ) {
    findEditorCanvas(
      first: $limit
      after: $after
      order: updatedAt_DESC
      where: $where
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        cursor
        node {
          objectId
          metadata
          editor_canvas_pages {
            edges {
              node {
                order
                preview {
                  url
                }
                gifPreviewId
              }
            }
          }
        }
      }
    }
  }
`;

export const FIND_PROJECT_TYPES = gql`
  query ProjectTypesDefault {
    findEditorProjectTypesDefault(order: order_ASC) {
      edges {
        node {
          objectId
          name
          createdAt
          isGlobal
        }
      }
    }
    findEditorProjectTypes(order: order_ASC) {
      edges {
        node {
          objectId
          name
          createdAt
        }
      }
    }
  }
`;

export const COUNT_PROJECTS_BY_FORMAT = gql`
  query FindUserCanvases($formatId: ID) {
    findEditorCanvas(
      where: {
        editor_project_formats_pointer: {
          have: { objectId: { equalTo: $formatId } }
        }
        status: { equalTo: "active" }
      }
    ) {
      count
    }
  }
`;

export const FIND_USER_RECENT_CANVASES = gql`
  query findUserRecentCanvases($limit: Int!, $where: Editor_canvasWhereInput) {
    findEditorCanvas(first: $limit, where: $where, order: updatedAt_DESC) {
      edges {
        node {
          objectId
          metadata
          status
          updatedAt
          editor_canvas_pages {
            edges {
              node {
                preview {
                  url
                }
                gifPreviewId
              }
            }
          }
        }
      }
    }
  }
`;
